import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import { composeAsync } from 'grey-group-function';
import { IAppInfo } from 'kts-platform-frame/dataModel';
import ReduxState, { IConfigApp } from 'kts-platform-frame/redux/ReduxState';
import { appStore } from 'kts-platform-frame/api';
import { AppType, AppSystemType } from 'kts-platform-frame/entry/constant';
import { JSString } from 'kts-scaffold-framework/utils/kit';
import { appIndexUri } from 'kts-platform-frame/entry/configUtils';
import { withRouter } from 'kts-platform-frame/routes';
import ModulesState from '../Modules.State';
import ModulesAction from '../Modules.Action';
import AppSdk from 'kts-platform-frame/appSdk';
import UIAppLoading from '../UI.AppLoading';

const css = require('./index.scss');

const IFRAME_NAME = 'kts-frame-name-app';

class UIAppContainerState {

    /** 请求的地址 */
    url: string = undefined;

    /** 是否加载中 */
    isloading: boolean = false;
}

/** Redux接口 */
interface IReduxStatePart {
    appConfig?: Map<string, IConfigApp>;
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
}

/** 绑定全局数据到props */
@withRouter
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
    appConfig: state.config.appList.map,
}))
export default class UIAppContainer extends UIBasic<IProps, ModulesState, UIAppContainerState> {

    state = new UIAppContainerState();

    /** 更新 */
    private currentKey: string;

    /** app 数据 */
    private appInfo: IAppInfo;

    /** 当前APP的路由 */
    private currentAppRouting: string;

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    /** 初始化 */
    componentDidMount() {
        AppSdk.instance.initialization();
        this.initApp();
    }

    /** 更新 */
    componentDidUpdate() {
        if (this.appKey !== this.currentKey) {
            this.initApp();
        } else {
            try {
                const appRouting = this.appRouting;
                if(this.currentAppRouting !== appRouting){
                    this.currentAppRouting = appRouting;
                    this.updateRoutingApp(appRouting, this.props.history.location.state);
                }
            } catch (error) {
                this.appInfo && this.updateIframeUrl(this.appInfo);
            }
        }
    }

    render() {
        let url = this.state.url; 
        if(url && url.lastIndexOf('/kts-app-apps/') >= 0){
            url = `${url.split('/kts-app-apps')[0]}/kts-app-apps?routing=${url.split('/kts-app-apps')[1]}` 
        } 
        return (
            <div className={css.iframe} key={this.appKey} >
                {this.state.isloading && <UIAppLoading />}
                {url && <iframe id="worbench" name={IFRAME_NAME} onLoad={this.onLoadIframeHandler} src={url} />}
            </div>
        );
    }

    /** 启动的appKey */
    private get appKey(): string {
        return this.props.match.params.appKey;
    }

    /** 获取APP的路由 */
    private get appRouting(): string {

        // 从 routing 参数中获取
        let routing = JSString.queryStringParse(window.location.search).routing as string;
        if (routing) {
            routing = routing.replace(/\/\//g, '/');
            if (routing.indexOf('/') === 0) {
                return `${routing}`;
            } else {
                return `/${routing}`;
            }
        }

        // 从 # 号后获取
        let pathname: string | string[] = window.location.href.split('#');
        if (pathname && pathname.length >= 2) {
            pathname = pathname[1];
            pathname = pathname.split('?')[0];

            let search: string | string[] = window.location.href.split('?');
            if (search && search.length >= 2) {
                search = search[1];
                search = search.split('#')[0];
            } else {
                search = '';
            }

            return search ? `/${pathname}?${search}` : `/${pathname}`;
        }

        return '';
    }

    /** 初始好 APP */
    private initApp = async () => {

        AppSdk.instance.offAll();

        this.setState({ isloading: true, url: null });

        let appInfo;
        if (this.currentKey === this.appKey) {
            appInfo = this.appInfo;
        } else {
            this.currentKey = this.appKey;
            appInfo = await this.getAppInfo(this.appKey);
        }

        if (appInfo) {
            this.appInfo = appInfo;
            this.updateIframeUrl(appInfo);
        }
    }

    /**
     * 获取 appKey 对应的 appInfo
     * @param appKey 
     */
    private getAppInfo = async (appKey: string): Promise<IAppInfo> => {
        const state = this.props.location.state as any;
        // 从路由状态获取
        if (state && state.appInfo && state.appInfo.appKey === appKey) {
            return state.appInfo;
        }

        // 从服务区获取
        const queryAppInfo = await appStore.queryAppInfo(this, { appKey });
        if (queryAppInfo.er) {
            let twoFactorAuth = queryAppInfo.er.body.status.returnCode === '54099' ? '/twoFactorAuth' : '';
            this.props.history.replace('/workbench/app/error' + twoFactorAuth);
            return null;
        }

        return queryAppInfo.res;
    }

    /** 获取 app 的 url 地址 */
    private getAppIndexUrl = (appInfo: IAppInfo): string => {
        let url = null;
        switch (appInfo.appType) {
            // 三条腿应用
            case AppType.legged3:
                url = JSString.isUrl(appInfo.appIndexUri);
                if (!url) {
                    this.props.history.replace('/workbench/app/error');
                }
                break;

            // 系统应用
            case AppType.system:
                url = this.getSystemAppUrl(appInfo);
                break;

            // APP类型错误
            default:
                console.error('APP类型错误');
        }

        return url;
    }

    /** 获取 系统应用 的app url */
    private getSystemAppUrl = (appInfo: IAppInfo): string => {
        const app = this.props.appConfig.get(appInfo.appKey);
        if (!app) {
            this.props.history.replace('/workbench/app/error');
            return null;
        }

        switch (app.TYPE) {
            case AppSystemType.核心功能:
                this.props.history.replace(app.URL);
                return null;

            case AppSystemType.潜入APP:
                return appIndexUri(appInfo.appKey);

            default:
                console.error('APP配置错误，APP类型错误');
                return null;
        }
    }

    /** iframe 加载完成 */
    private onLoadIframeHandler = async () => {
        this.setState({ isloading: false });
    }

    /** 更新app路由的状态 */
    private updateRoutingApp = (pathname: string, state: any) => {
        if (!window.frames[IFRAME_NAME]) {
            return;
        }

        try {
            window.frames[IFRAME_NAME].appHistory.replace(pathname, state);
        } catch (error) {
        }
    }

    /** 更新iframe的地址 */
    private updateIframeUrl = composeAsync<IAppInfo, void>(
        this.getAppIndexUrl,
        url => {
            if (this.state.url !== url + this.appRouting) {
                this.setState({ url: url + this.appRouting });
            }
        }
    );
}


// WEBPACK FOOTER //
// ./src/display/modules/Home/Workbench/UI.AppContainer/index.tsx